import { render, staticRenderFns } from "./viewIncomeStatement.vue?vue&type=template&id=45ce2132&scoped=true&"
import script from "./viewIncomeStatement.vue?vue&type=script&lang=js&"
export * from "./viewIncomeStatement.vue?vue&type=script&lang=js&"
import style0 from "./viewIncomeStatement.vue?vue&type=style&index=0&id=45ce2132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce2132",
  null
  
)

export default component.exports